import { rem } from "polished";
import styled from "styled-components";

import { APP_WIDTH } from "styles";

export const Form = styled.form`
  @media (min-width: ${APP_WIDTH}px) {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid #f1f1f1;
    border-radius: ${rem(8)};
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.06);
  }
`;
